import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  key: 0,
  class: "section-wrap"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "flex": "1",
    "background": "var(--background)",
    "border-radius": "1rem",
    "overflow": "hidden",
    "aspect-ratio": "3 / 2"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "flex-end",
    "gap": "0.75rem",
    "padding": "0.75rem 0.75rem 1rem"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "1rem"
  }
};
const _hoisted_6 = {
  class: "contest-grid"
};
import { computed, onMounted, ref } from "vue";
// import { useRouter } from "vue-router";
// import dayjs from "dayjs";
import { useMediaQuery } from "@vueuse/core";
import request from "@/utils/request";
import toast from "@/utils/toast";
import CompetitionLayout from "@/components/CompetitionLayout.vue";
import CompetitionSignUpDialog from "@/components/CompetitionSignUpDialog.vue";
import CompetitionSubmitDialog from "@/components/CompetitionSubmitDialog.vue";
// import CompetitionListHead from "./CompetitionListHead.vue";
import CompetitionListItem from "./CompetitionListItem.vue";

// const $router = useRouter();

export default {
  __name: 'CompetitionList',
  setup(__props) {
    const isPad = useMediaQuery("(max-width: 1039px)");
    const isMobile = useMediaQuery("(max-width: 767px)");

    // const headerData = ref({});
    // const queryHeaderData = async () => {
    //   try {
    //     const res = await request.get("/contest/statistics");
    //     const { code, data } = res;
    //     if (code === 200) {
    //       headerData.value = data;
    //     }
    //   } catch (err) {
    //     console.error(err);
    //   }
    // };

    // const metaData = ref({});
    // const queryMetaData = async () => {
    //   try {
    //     const res = await request.get("/contest/meta");
    //     const { code, data } = res;
    //     if (code === 200) {
    //       metaData.value = data;
    //     }
    //   } catch (err) {
    //     console.error(err);
    //   }
    // };

    const filter = ref({
      status: "all",
      categories: ["all"],
      order: "new"
    });

    // const handleCategoryClick = (category) => {
    //   if (category === "all") {
    //     filter.value.categories = ["all"];
    //   } else {
    //     filter.value.categories = filter.value.categories.filter((c) => c !== "all");
    //     if (!filter.value.categories.includes(category)) {
    //       filter.value.categories.push(category);
    //     } else {
    //       filter.value.categories = filter.value.categories.filter((c) => c !== category);
    //     }
    //   }
    // };

    // 报名
    const showSignUp = ref(false);

    // 提交
    const showSubmit = ref(false);
    const loading = ref(false);
    const list = ref([]);

    // const hotList = computed(() => list.value.filter((item) => item.section === "featured"));
    // const activeList = computed(() => list.value.filter((item) => item.section === "ongoing"));
    // const endedList = computed(() => list.value.filter((item) => item.section === "ended"));
    const allList = computed(() => [
      // {
      //   title: "2026 山海杯 · AIGC 创作大赛",
      //   sub_title: "你的每一笔，都有回响。\n你造的梦，有人帮你点亮。\n百万奖金，给敢想的人加冕。\n全链开发，让好作品跃出屏幕。\n来这里!\n让你的创意，不止于想象。",
      //   bonus_pool_amount: 1300000,
      //   organizer: "芒果灵创",
      //   deadline: "2026-05-05",
      //   regNum: 3284,
      //   workNum: null,
      //   viewNum: 58234,
      //   status: "registering",
      //   isHot: true,
      //   badges: [
      //     { type: "featured", label: "✦ 年度旗舰" },
      //     { type: "hot", label: "🔥 火热" },
      //   ],
      //   tags: [
      //     { type: "cat", label: "漫剧" },
      //     { type: "theme", label: "东方奇幻" },
      //     { type: "theme", label: "神话改编" },
      //     { type: "team", label: "个人/团队" },
      //   ],
      //   itemStyle: {
      //     "animation-delay": "0.04s",
      //   },
      //   bgStyle: {
      //     background: "linear-gradient(135deg, #0a0818 0%, #2a0e3a 40%, #180408 70%, #0e1a04 100%)",
      //   },
      // },
    ].concat(list.value));
    const currentItem = ref({});
    const handleShowSignUp = item => {
      currentItem.value = item;
      showSignUp.value = true;
    };
    const handleSignUp = () => {
      currentItem.value.registered = true;
    };
    const handleShowSubmit = item => {
      currentItem.value = item;
      showSubmit.value = true;
    };
    const queryList = async () => {
      loading.value = true;
      try {
        const params = {
          ...filter.value
        };
        const res = await request.get("/contest/list", params);
        const {
          code,
          data
        } = res;
        if (code === 200) {
          list.value = data?.list || [];
        }
      } catch (err) {
        console.error(err);
        toast("获取赛事列表失败");
        list.value = [];
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => {
      // queryHeaderData();
      // queryMetaData();
      queryList();
    });

    // watchEffect(() => {
    //   queryList();
    // }, [filter.value]);

    return (_ctx, _cache) => {
      const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
      const _component_el_skeleton = _resolveComponent("el-skeleton");
      return _openBlock(), _createBlock(CompetitionLayout, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [allList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "sec-header"
        }, [_createElementVNode("div", {
          class: "sec-title"
        }, " 热门赛事 ")], -1)), _createVNode(_component_el_skeleton, {
          style: {
            "display": "flex",
            "gap": "1.5rem"
          },
          loading: loading.value,
          animated: "",
          count: _unref(isMobile) ? 1 : _unref(isPad) ? 2 : 3
        }, {
          template: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_skeleton_item, {
            variant: "image",
            style: {
              "height": "240px",
              "background": "var(--popover)"
            }
          }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_skeleton_item, {
            variant: "h3",
            style: {
              "width": "50%",
              "background": "var(--popover)"
            }
          }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_skeleton_item, {
            variant: "text",
            style: {
              "width": "30%",
              "background": "var(--popover)"
            }
          }), _createVNode(_component_el_skeleton_item, {
            variant: "text",
            style: {
              "width": "15%",
              "background": "var(--popover)"
            }
          })])])])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allList.value, (item, i) => {
            return _openBlock(), _createBlock(CompetitionListItem, {
              key: item.title,
              index: i,
              competition: item,
              onSignUp: $event => handleShowSignUp(item),
              onSubmitWork: $event => handleShowSubmit(item)
            }, null, 8, ["index", "competition", "onSignUp", "onSubmitWork"]);
          }), 128))])]),
          _: 1
        }, 8, ["loading", "count"])])) : _createCommentVNode("", true)]), _createVNode(CompetitionSignUpDialog, {
          modelValue: showSignUp.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showSignUp.value = $event),
          data: currentItem.value,
          onSubmit: handleSignUp
        }, null, 8, ["modelValue", "data"]), _createVNode(CompetitionSubmitDialog, {
          modelValue: showSubmit.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showSubmit.value = $event),
          data: currentItem.value
        }, null, 8, ["modelValue", "data"])]),
        _: 1
      });
    };
  }
};